import {
  GET_ADDON_PRODUCTS,
  UPDATE_ADDON_PRODUCTS,
  SET_ADDON_PRODUCTS_LOADING,
  SHOW_EDIT_PRICE_MODAL,
  SET_PRICE_EDITOR_LOADING,
  SET_PRICE_EDITOR_ERROR,
  UPDATE_ADDON_PRODUCT_PRICE,
  ADDITIONAL_SERVICE_DO_SHOW_LOG,
  ADDITIONAL_SERVICE_LOG_SET_SHOWN,
  ADDITIONAL_SERVICE_LOG_CHANGE_PAGE,
  ADDITIONAL_SERVICE_LOG_SET_DATA,
  ADDITIONAL_SERVICE_LOG_SET_IS_LOADING,
  ADDITIONAL_SERVICE_LOG_SET_ERRORS,
} from './actionTypes';

export const getAddonProducts = () => ({
  type: GET_ADDON_PRODUCTS,
});

export const updateAddonProducts = products => ({
  type: UPDATE_ADDON_PRODUCTS,
  payload: products,
});

export const setAddonProductsLoading = isLoading => ({
  type: SET_ADDON_PRODUCTS_LOADING,
  payload: isLoading,
});

export const showEditPriceModal = (shown, product = null) => ({
  type: SHOW_EDIT_PRICE_MODAL,
  payload: { shown, product },
});

export const setPriceEditorLoading = isLoading => ({
  type: SET_PRICE_EDITOR_LOADING,
  payload: isLoading,
});

export const setPriceEditorError = errorMessage => ({
  type: SET_PRICE_EDITOR_ERROR,
  payload: errorMessage,
});

export const updateAddonProductPrice = (productId, priceData) => ({
  type: UPDATE_ADDON_PRODUCT_PRICE,
  payload: { productId, priceData },
});

export const doShowLogs = () => ({
  type: ADDITIONAL_SERVICE_DO_SHOW_LOG,
});

export const setLogModalShown = shown => ({
  type: ADDITIONAL_SERVICE_LOG_SET_SHOWN,
  payload: { shown },
});

export const setLogPage = page => ({
  type: ADDITIONAL_SERVICE_LOG_CHANGE_PAGE,
  payload: { page },
});

export const setLogData = (data, paging) => ({
  type: ADDITIONAL_SERVICE_LOG_SET_DATA,
  payload: { data, paging },
});

export const resetLogData = () =>
  setLogData([], { page: 1, size: 20, total: 0 });

export const setLogIsLoading = isLoading => ({
  type: ADDITIONAL_SERVICE_LOG_SET_IS_LOADING,
  payload: { isLoading },
});

export const setLogErrors = errors => ({
  type: ADDITIONAL_SERVICE_LOG_SET_ERRORS,
  payload: { errors },
});

export const clearLogErrors = () => setLogErrors([]);
